module.exports = __webpack_public_path__ + "static/img/xin.a113472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xin.png
// module id = MJhb
// module chunks = 2